import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ConfigKeys } from '../../../../shared/interfaces/config.interface';
import { ConfigService } from '../../../../shared/services/config.service';

@Injectable({
  providedIn: 'root',
})
export class ReceivedDeliveryNotesService {
  private basePath: string;

  constructor(
    private httpClient: HttpClient,
    private readonly config: ConfigService
  ) {
    this.basePath = config.get(ConfigKeys.API_BASE_PATH);
  }
}
